import router from '@/core/router.js';
import request from '@/utilities/request';

export default {
  async forgotPassword({ commit, state, rootState }, { email }) {
    commit('setIsLoading', true);
    commit('setSignInErrMsg', '');

    let recaptchaToken = '';
    let siteKey = '';

    try {
      const recaptchaResult = await state.recaptcha.execute('forgotPassword');
      recaptchaToken = recaptchaResult.token;
      siteKey = recaptchaResult.siteKey;
    } catch (error) {
      // ignore
    }

    return request
      .post('/signin/module.php/tmauth/forgotpassword', {
        recaptchaToken,
        siteKey,
        email,
        locale: rootState.userLang,
      })
      .then(() => {
        commit('setIsLoading', false);
        router.push({ name: 'auth/forgotPwdSent' });
      })
      .catch((err) => {
        commit('setIsLoading', false);
        // 設定錯誤訊息
        if (err.response?.data?.code) {
          const errorCode = err.response.data.code;
          // 根據錯誤代碼設定對應的錯誤訊息
          if (errorCode === 'MISSING_EMAIL') {
            commit('setSignInErrMsg', state.lang.forgotPwdEmailRequired || 'Email is required');
          } else if (errorCode === 'RECAPTCHA_FAILED') {
            commit('setSignInErrMsg', state.lang.recaptchaFailed || 'reCAPTCHA verification failed');
          } else {
            commit('setSignInErrMsg', err.response.data.error || state.lang.errorOccurred);
          }
        } else {
          commit('setSignInErrMsg', state.lang.errorOccurred || 'An error occurred');
        }
        throw err;
      });
  },

  async resetPassword({ commit, state, dispatch }, { token, newPassword, confirmPassword }) {
    commit('setIsLoading', true);
    commit('setSignInErrMsg', '');

    return request
      .post('/signin/module.php/tmauth/resetpassword', {
        token,
        newPassword,
        confirmPassword,
      })
      .then(() => {
        commit('setIsLoading', false);

        dispatch(
          'triggerEvent',
          {
            eventName: 'ResetPasswordSuccess',
          },
          { root: true },
        );

        router.push({ name: 'auth/resetPwdSuccess' });
      })
      .catch((err) => {
        commit('setIsLoading', false);

        dispatch(
          'triggerEvent',
          {
            eventName: 'ResetPasswordFail',
            addInfo: {
              http_code: err.response?.status,
              error_code: err.response?.data?.code,
            },
          },
          { root: true },
        );

        // 設定錯誤訊息
        if (err.response?.data?.code) {
          const errorCode = err.response.data.code;
          // 根據錯誤代碼設定對應的錯誤訊息
          if (errorCode === 'INVALID_TOKEN') {
            commit('setSignInErrMsg', state.lang.resetPwdTokenInvalid || 'Reset link is invalid or expired');
          } else if (errorCode === 'WEAK_PASSWORD') {
            commit('setSignInErrMsg', state.lang.resetPwdPasswordTooWeak || 'Password is too weak');
          } else if (errorCode === 'PASSWORD_MISMATCH') {
            commit('setSignInErrMsg', state.lang.resetPwdMismatch || 'Passwords do not match');
          } else if (errorCode === 'INVALID_PASSWORD_FORMAT') {
            commit('setSignInErrMsg', state.lang.resetPwdInvalidFormat || 'Password must be 8-50 characters');
          } else if (errorCode === 'MISSING_FIELDS') {
            commit('setSignInErrMsg', state.lang.resetPwdMissingFields || 'All fields are required');
          } else {
            commit('setSignInErrMsg', err.response.data.error || state.lang.errorOccurred);
          }
        } else {
          commit('setSignInErrMsg', state.lang.errorOccurred || 'An error occurred');
        }
        throw err;
      });
  },
};
